import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Footer() {
  return (
    <footer className="bg-background-100">
      <div className="w-full max-w-[1440px] mx-auto px-4 md:px-8">
        {/* Main footer content */}
        <div className="py-12 md:py-16">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
            {/* Brand column */}
            <div className="lg:col-span-1">
              <Link to="/" className="flex items-center gap-2 mb-4">
                <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-primary-500">
                  <i className="ri-table-line text-base text-background-50"></i>
                </div>
                <span className="font-heading text-lg font-semibold text-foreground-950">
                  Superbuy Spreadsheet
                </span>
              </Link>
              <p className="text-sm text-foreground-500 leading-relaxed mb-4">
                The most complete Superbuy Spreadsheet knowledge platform. Guides, templates, and tutorials to help you shop smarter.
              </p>
              <div className="flex items-center gap-3">
                <a
                  href="https://kaspreadsheet.com"
                  target="_blank"
                  rel="noopener nofollow"
                  className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-200/70 text-foreground-500 hover:text-primary-500 hover:bg-primary-50 transition-colors cursor-pointer"
                  aria-label="Visit Kaspreadsheet"
                >
                  <i className="ri-external-link-line"></i>
                </a>
                <a
                  href="https://kaspreadsheet.com"
                  target="_blank"
                  rel="noopener nofollow"
                  className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-200/70 text-foreground-500 hover:text-primary-500 hover:bg-primary-50 transition-colors cursor-pointer"
                  aria-label="Twitter"
                >
                  <i className="ri-twitter-x-line"></i>
                </a>
              </div>
            </div>

            {/* Guides column */}
            <div>
              <h4 className="text-xs font-semibold text-foreground-400 uppercase tracking-widest mb-4">Guides</h4>
              <ul className="space-y-3">
                <li>
                  <Link to="/superbuy-spreadsheet-guide" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors">
                    Complete Guide 2026
                  </Link>
                </li>
                <li>
                  <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors">
                    Beginner Tutorial
                  </a>
                </li>
                <li>
                  <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors">
                    Template Download
                  </a>
                </li>
                <li>
                  <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors">
                    Product Tracking
                  </a>
                </li>
              </ul>
            </div>

            {/* Categories column */}
            <div>
              <h4 className="text-xs font-semibold text-foreground-400 uppercase tracking-widest mb-4">Categories</h4>
              <ul className="space-y-3">
                {categories.slice(0, 7).map((cat) => (
                  <li key={cat.name}>
                    <a
                      href={cat.url}
                      target="_blank"
                      rel="noopener nofollow"
                      className="text-sm text-foreground-600 hover:text-primary-600 transition-colors"
                    >
                      {cat.name}
                    </a>
                  </li>
                ))}
              </ul>
            </div>

            {/* More Categories column */}
            <div>
              <h4 className="text-xs font-semibold text-foreground-400 uppercase tracking-widest mb-4">More</h4>
              <ul className="space-y-3">
                {categories.slice(7).map((cat) => (
                  <li key={cat.name}>
                    <a
                      href={cat.url}
                      target="_blank"
                      rel="noopener nofollow"
                      className="text-sm text-foreground-600 hover:text-primary-600 transition-colors"
                    >
                      {cat.name}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="py-5 border-t border-background-200/70 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-400">
            &copy; 2026 superbuyspread.study &mdash; The Superbuy Spreadsheet Resource Platform
          </p>
          <div className="flex items-center gap-4 text-xs text-foreground-400">
            <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="hover:text-foreground-600 transition-colors">
              Privacy
            </a>
            <span>|</span>
            <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="hover:text-foreground-600 transition-colors">
              Terms
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}